<template>
  <dashboard>
    <template v-slot:content>
      <section>
        <b-container fluid>
          <div class="d-none" v-html="stringHtml"></div>
          <div class="header-elements align-items-center">
            <b-row class="mt-2">
              <b-col lg="12" md="12">
                <b-row class>
                  <b-col lg="7" md="7">
                    <h5
                      class="mt-2"
                      :class="[grn != '' ? 'text-success' : null]"
                    >
                      <img
                        src="@/assets/images/big_tick.svg"
                        width="20"
                        v-if="grn != ''"
                      />
                      {{ Title }}
                    </h5>
                  </b-col>
                  <b-col lg="5" md="5">
                    <b-button
                      variant="dark"
                      class="float-right"
                      v-if="grn != ''"
                      @click="backAdvice"
                      >Back to Advice</b-button
                    >
                    <b-row
                      class="form-row grn-search"
                      vertical-align="center"
                      v-if="grn == ''"
                    >
                      <b-col md="9" class="pr-0">
                        <b-input-group size="md" class="box-shadow">
                          <b-input-group-text slot="prepend">
                            <font-awesome-icon :icon="['fas', 'search']" />
                          </b-input-group-text>
                          <b-form-input
                            v-model="search"
                            :disabled="$loading"
                            autocomplete="off"
                            placeholder="Enter barcode or search products"
                            class="search"
                            autofocus
                          ></b-form-input>
                        </b-input-group>
                      </b-col>
                      <b-col cols="3" md="3">
                        <b-button
                          variant="secondary"
                          class="w-100"
                          @click="createGrn"
                          >Create GRN</b-button
                        >
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
        </b-container>
      </section>
      <section class="fadein grn-modal">
        <b-container fluid>
          <div class="customer-info table-dark-bg box-shadow mt-2 mb-3 p-4">
            <b-form v-on:submit.prevent>
              <b-row v-if="grn == ''">
                <b-col lg="2" class="text-left">
                  <label for class="mb-0">Advice Number</label>
                  <b-input
                    readonly
                    :value="advice.advice_no"
                    type="text"
                  ></b-input>
                </b-col>
                <b-col lg="2" class="text-left">
                  <label for class="mb-0">Advice Date</label>
                  <b-input readonly :value="advice.date" type="text"></b-input>
                </b-col>
                <b-col lg="2" class="text-left">
                  <label for class="mb-0">Supplier</label>
                  <b-input
                    readonly
                    :value="advice.supplier"
                    type="text"
                  ></b-input>
                </b-col>
                <b-col lg="2" class="text-left">
                  <label for class="mb-0">Place of Origin</label>
                  <b-input
                    readonly
                    :value="advice.origin_from"
                    type="text"
                  ></b-input>
                </b-col>
                <b-col lg="4" class="text-left">
                  <label for class="mb-0">Remarks</label>
                  <b-form-input
                    type="text"
                    placeholder="Add Remarks"
                    autocomplete="off"
                    v-model="billRemarks"
                  ></b-form-input>
                </b-col>
                <!-- <b-button class="btn-theme" v-b-modal.modal-edit>Edit Qty</b-button>
                <img src="@/assets/images/checkbox_off.svg" alt=" " />
                <img src="@/assets/images/checkbox_on.svg" alt=" " />-->

                <b-modal
                  ref="remark-modal"
                  size="md"
                  class="modal"
                  hide-footer
                  centered
                  title="Add Remarks"
                >
                  <b-form-textarea
                    id="textarea"
                    v-model="remarks.value"
                    placeholder="Enter Remarks..."
                    rows="4"
                    no-resize
                    autofocus
                  ></b-form-textarea>
                  <div class="text-right">
                    <b-button
                      class="mt-3 btn-theme grey-btn"
                      variant="success"
                      type="submit"
                      @click="saveRemarks"
                      >Save</b-button
                    >
                  </div>
                </b-modal>

                <b-modal
                  ref="quantity-modal"
                  title="Product Name & Description"
                  centered
                  size="lg"
                  class="pb-0"
                  no-close-on-esc
                  modal-class="quantity-modal"
                  no-close-on-backdrop
                  hide-footer
                  header-class="qty-header"
                >
                  <template slot="modal-header">
                    <b-container>
                      <b-row>
                        <b-col class="p-0">
                          <h3 class="modal-title">
                            {{ modalData.product_name }} &
                            {{ modalData.product_desc }}
                          </h3>
                        </b-col>
                        <b-col class="p-0">
                          <b-button
                            variant="success"
                            class="float-right"
                            :disabled="updateBtnQty"
                            @click="updateQty(modalData.barcode)"
                            >Update Quantity</b-button
                          >
                          <b-button
                            style="margin-right:10px;"
                            variant="danger"
                            class="float-right"
                            @click="closeQtyModal"
                            >Close</b-button
                          >
                        </b-col>
                      </b-row>
                    </b-container>
                  </template>
                  <b-row>
                    <b-col>
                      <label for>Ordered Quantity</label>
                      <b-input
                        type="number"
                        readonly
                        :value="modalData.ordered"
                      ></b-input>
                    </b-col>
                    <b-col>
                      <label for>Received Quantity</label>
                      <b-input
                        placeholder="0"
                        type="number"
                        v-model="received_qty"
                        :readonly="modalData.tracking != ''"
                        @click="received_qty = ''"
                      ></b-input>
                    </b-col>
                    <b-col>
                      <label for>Damaged Quantity</label>
                      <b-input
                        placeholder="0"
                        type="number"
                        v-model="damage_qty"
                        :readonly="modalData.tracking != ''"
                        @click="damage_qty = ''"
                      ></b-input>
                    </b-col>
                  </b-row>

                  <div v-if="modalData.tracking != ''">
                    <hr />
                    <div class="pt-1 pb-3 text-right justify-content-end">
                      <!-- <b-button size="sm" variant="light" class="ml-3" @click=" ">Add Quantity</b-button> -->
                      <b-button
                        size="sm"
                        class="btn-theme ml-3"
                        @click="addRow('Batch')"
                        v-if="
                          modalData.tracking == 'Batch' ||
                            modalData.tracking == 'Batch/Serial'
                        "
                        >Add Batch</b-button
                      >
                      <b-button
                        size="sm"
                        class="btn-theme ml-3 mr-0"
                        @click="addRow('Serial')"
                        v-if="
                          modalData.tracking == 'Serial' ||
                            modalData.tracking == 'Batch/Serial'
                        "
                        >Add Serial</b-button
                      >
                    </div>

                    <div>
                      <div class="padding-less-table p-0">
                        <table class="table cart-table mt-3 table-dark">
                          <thead>
                            <tr class="sticky-top">
                              <th>#</th>
                              <th>Batch/Serial</th>
                              <th>Received Qty</th>
                              <th>Damaged Qty</th>
                              <th width="30"></th>
                            </tr>
                          </thead>
                          <tbody v-if="list != ''" class="grn-popup">
                            <tr v-for="(item, index) in list" :key="index">
                              <td v-text="index + 1"></td>
                              <td>
                                <b-row>
                                  <b-col md="3">
                                    <label v-text="item.type"></label>
                                  </b-col>
                                  <b-col>
                                    <b-input
                                      placeholder="Batch Number"
                                      type="text"
                                      v-model="item.number"
                                      autocomplete="off"
                                    ></b-input>
                                  </b-col>
                                </b-row>
                              </td>
                              <td>
                                <b-input
                                  placeholder="0"
                                  type="number"
                                  v-model="item.received"
                                  autocomplete="off"
                                  @input="changeQty()"
                                ></b-input>
                              </td>
                              <td>
                                <b-input
                                  placeholder="0"
                                  type="number"
                                  v-model="item.damaged"
                                  autocomplete="off"
                                  @input="changeQty()"
                                ></b-input>
                              </td>
                              <td>
                                <button
                                  type="button"
                                  class="btn btn-danger w-100"
                                  @click="removeRow(index)"
                                >
                                  X
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div
                        class="d-flex align-items-center text-center d-none update-qty"
                        style="height:100%"
                        v-if="list == ''"
                      >
                        <h6 class="fw-normal w-100" style>
                          Click on Add Serial / Add Batch to start adding
                          quantities.
                        </h6>
                      </div>
                    </div>
                  </div>
                </b-modal>
              </b-row>

              <b-row v-if="grn != ''">
                <b-col md="2 pb-3">
                  <label for class="m-0">GRN Number</label>
                  <p>{{ grn.grn_no }}</p>
                </b-col>
                <b-col md="2 pb-3">
                  <label for class="m-0">Date</label>
                  <p>{{ grn.date }}</p>
                </b-col>
                <b-col md="2 pb-3">
                  <label class="m-0">Received Quantity</label>
                  <p>{{ grn.received_qty }}</p>
                </b-col>
                <b-col md="2 pb-3">
                  <label class="m-0">Damaged Quantity</label>
                  <p>{{ grn.damage_qty }}</p>
                </b-col>
                <b-col md="2 pb-3">
                  <label class="m-0">Lost Quantity</label>
                  <p>{{ grn.lost_qty }}</p>
                </b-col>
                <b-col md="2 pb-3">
                  <label class="m-0">Supplier</label>
                  <p>{{ grn.supplier }}</p>
                </b-col>
                <b-col md="2 ">
                  <label class="m-0">Place of Origin</label>
                  <p>{{ grn.place_from }}</p>
                </b-col>
                <b-col md="6">
                  <label class="m-0">Bill Remarks</label>
                  <p>{{ grn.remarks }}</p>
                </b-col>
                <b-col md="2" class="text-right offset-md-2">
                  <b-button class="btn btn-theme w-100" @click="printGrn()">
                    <span>Print Receipt</span>
                    <!-- <font-awesome-icon icon="print" size="lg" /> -->
                  </b-button>
                </b-col>
                <b-modal
                  ref="print-grn"
                  hide-header
                  hide-footer
                  centered
                  @hidden="hidePrintModal"
                >
                  <div
                    class="modal-head"
                    style="border-bottom: 1px #c0c0c0 solid;"
                  >
                    <b-row class="pb-3 print_box">
                      <b-col>
                        <h3 class="modal-title">Invoice</h3>
                      </b-col>
                      <b-col>
                        <b-button
                          class="float-right grey-outline-btn"
                          @click="printInvoice"
                          >Print</b-button
                        >
                        <b-button
                          style="margin-right:10px;"
                          class="float-right grey-outline-btn"
                          @click="hidePrintModal"
                          >Close</b-button
                        >
                      </b-col>
                    </b-row>
                  </div>
                  <div id="cool">
                    <print-box :data="html"></print-box>
                  </div>
                  <!-- <template slot="modal-footer" center>
          <b-button variant="success" size="lg" @click="printInvoice">Print</b-button>
            <b-button variant="danger" @click="hidePrintModal">Cancel</b-button>
                  </template>-->
                </b-modal>
              </b-row>
              <!-- <b-row v-if="grn != ''">
                <b-col md="2">
                  <label>Place of Origin</label>
                  <p>{{ grn.place_from }}</p>
                </b-col>
                <b-col md="8">
                  <label>Bill Remarks</label>
                  <p>{{ grn.remarks }}</p>
                </b-col>
              </b-row>-->
            </b-form>
          </div>
        </b-container>
      </section>

      <section>
        <b-container fluid>
          <div
            class="table-dark-bg box-shadow cart-table-wrapper wow fadeIn grn"
            v-bind:class="{ grnBox: isApply }"
          >
            <table class="table cart-table mt-0 table-dark">
              <thead>
                <tr>
                  <th class="text-center pr-2">#</th>
                  <th width="20%" class="text-left pl-0">Product(s)</th>
                  <th class="text-center">Inventory Track</th>
                  <th class="text-center">Ordered Qty.</th>
                  <th class="text-center" v-if="advice.status == 'PARTIAL'">
                    Remaining Qty.
                  </th>
                  <th class="text-center">Received Qty.</th>
                  <th class="text-center">Damaged Qty.</th>
                  <th class="text-center">Short/Excess</th>
                  <th class="text-center">Remarks</th>
                  <th class="text-center" v-if="grn == ''">Status</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in GRNitems" :key="index">
                  <td class="text-center pr-2" v-text="index + 1"></td>
                  <td style="padding-left: 0px !important;">
                    <p class="mb-0">
                      {{ item.product_name }}
                      <br />
                      <span>{{ item.barcode }}</span>
                    </p>
                  </td>
                  <td class="text-center">
                    <p class="mb-0" v-if="item.tracking.length > 1">
                      {{ item.tracking }}
                    </p>
                    <p class="mb-0" v-else></p>
                  </td>
                  <td class="text-center" v-text="item.ordered"></td>
                  <td class="text-center" v-if="advice.status == 'PARTIAL'">
                    {{ item.remaining }}
                  </td>
                  <td class="text-center" v-text="item.received"></td>
                  <td class="text-center" v-text="item.damaged"></td>
                  <td class="text-center" v-text="item.lost"></td>
                  <td class="text-center">
                    <a
                      href="javascript:void(0)"
                      @click="openRemarks(item)"
                      class="w-100 text-muted"
                      v-if="item.remarks == '' && grn == ''"
                    >
                      <font-awesome-icon :icon="['fas', 'plus']" />&nbsp; Add
                      Remarks
                    </a>
                    <div v-else>
                      <b-button
                        v-b-tooltip.hover
                        :title="item.remarks"
                        @click="openRemarks(item)"
                        variant="outline-secondary"
                        v-if="item.remarks != '' && grn == ''"
                        >Edit</b-button
                      >
                    </div>
                    <h6
                      style="font-weight: normal"
                      v-if="grn != ''"
                      v-text="item.remarks"
                    ></h6>
                  </td>
                  <td class="text-center" v-if="grn == ''">
                    <label class="text-success" v-if="item.status == 'Surplus'"
                      >Surplus</label
                    >
                    <label class="text-danger" v-if="item.status == 'Deficit'"
                      >Deficit</label
                    >
                  </td>
                  <td class="float-right mr-2">
                    <b-button
                      @click="openQty(item)"
                      variant="secondary"
                      class="grey-btn"
                      v-if="grn == ''"
                      >Update Qty</b-button
                    >
                    <b-button
                      variant="secondary"
                      v-if="grn != ''"
                      :disabled="item.is_batch == 0 && item.is_serial == 0"
                      @click="openDetails(item)"
                      >Details</b-button
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-container>
      </section>
      <b-modal
        ref="grn-details-modal"
        title="Product Name & Description"
        no-close-on-backdrop
        hide-footer
        centered
        scrollable
      >
        <p class="batch-serial mb-2">Barcode {{ grnBatchSerial.barcode }}</p>
        <table class="table-grn table text-center">
          <thead>
            <tr>
              <th>#</th>
              <th>Batch/Serial</th>
              <th></th>
              <th>Received Qty.</th>
              <th>Damage Qty.</th>
              <!-- <th>Valid Till</th>
              <th>Amount</th>-->
            </tr>
          </thead>
          <tbody>
            <tr v-for="list in grnBatchSerial.batch" :key="list.id">
              <td></td>
              <!-- <td v-text="list.id"></td> -->
              <td>
                <p class="m-0">Batch</p>
              </td>
              <td>
                <p class="m-0">{{ list.batch_no }}</p>
              </td>
              <td>
                <p class="m-0">{{ grnBatchSerial.received_qty }}</p>
              </td>
              <td>
                <p class="m-0">{{ grnBatchSerial.damage_qty }}</p>
              </td>
            </tr>
            <tr v-for="(list, index) in grnBatchSerial.serial" :key="list.id">
              <td v-text="index + 1"></td>
              <!-- <td v-text="list.id"></td> -->
              <td>
                <p class="m-0">Serial</p>
              </td>
              <td>
                <p class="m-0">{{ list.serial_no }}</p>
              </td>
              <td>
                <p class="m-0">1</p>
              </td>
              <td style="opacity: 0.5">
                <p class="m-0">0</p>
              </td>
              <!-- <td v-text="list.expire_at"></td>
              <td v-text="list.amount"></td>-->
            </tr>
          </tbody>
        </table>
      </b-modal>
    </template>
  </dashboard>
</template>

<script>
import { validationMixin } from "vuelidate";
import Dashboard from "../views/Dashboard";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faQuestionCircle } from "@fortawesome/free-regular-svg-icons";
import axios from "axios";
import { mapState } from "vuex";
import { faPrint } from "@fortawesome/free-solid-svg-icons";
import * as msg from "../message";
import PrintBox from "../components/PrintBox";
import qz from "../printer";
library.add(faPrint);
//import { mapState } from 'vuex'
library.add(faQuestionCircle);

export default {
  mixins: [validationMixin],
  name: "generate-grn",
  props: ["id"],
  components: {
    Dashboard,
    PrintBox,
  },
  mounted() {
    this.fetchGRNList();
    // this.GRNitems;
  },

  data() {
    return {
      Title: "Goods Receipt Note",
      selected: null,
      searchableName: true,
      html: "",
      isBusy: false,
      remarks: {
        barcode: "",
        value: "",
      },
      GRNList: [],
      isApply: false,
      grn: "",
      advice: [],
      search: "",
      form: {
        adviceNo: "",
        date: "",
        SupplierList: "Please select",
        GRNno: "",
        date2: "",
        scanno: "",
      },
      modalData: [],
      received_qty: 0,
      damage_qty: 0,
      list: [],
      stringHtml: "",
      billRemarks: "",
      grnBatchSerial: [],
    };
  },
  computed: {
    ...mapState({
      state: (state) => state,
      customerData() {
        return this.$store.getters["sessions/getCustomerParam"];
      },
    }),
    GRNitems() {
      let data = [];
      let result = "";
      this.GRNList.map(function(item, index) {
        data.push({
          id: index + 1,
          product_desc: item.item_desc,
          product_name: item.name,
          ordered: item.order_qty,
          barcode: item.barcode,
          received: item.received_qty,
          remaining: item.remaining_qty,
          lost: item.lost_qty,
          damaged: item.damage_qty,
          remarks: item.remarks,
          tracking: item.status,
          status: item.temp_status,
          OK: "",
          batch: item.batch,
          serial: item.serial,
        });
      });

      result = data;

      if (!this.search) {
        return result;
      }

      const filterValue = this.search.toLowerCase();

      const filter = (event) =>
        event.product_name.toLowerCase().includes(filterValue) ||
        event.product_desc.toLowerCase().includes(filterValue) ||
        event.barcode.toLowerCase().includes(filterValue);

      return result.filter(filter);
    },
    updateBtnQty() {
      let isDisabled = true;
      if (this.list.length > 0) {
        // console.log("Cool");
        if (this.received_qty > 0 || this.damage_qty > 0) {
          isDisabled = false;
        } else {
          isDisabled = true;
        }
        this.list.map((item) => {
          if (item.number == "" || item.number == 0) {
            isDisabled = true;
          }
        });
      } else {
        // console.log("Not Cool");
        if (this.received_qty > 0 || this.damage_qty > 0) {
          isDisabled = false;
        } else {
          isDisabled = true;
        }
      }
      return isDisabled;
    },
  },
  methods: {
    openDetails(item) {
      this.grnBatchSerial = item;
      this.$refs["grn-details-modal"].show();
    },
    contentShow(content) {
      this.isContentShow = content;
    },
    openRemarks(data) {
      this.remarks.barcode = data.barcode;
      this.remarks.value = data.remarks;
      this.$refs["remark-modal"].show();
    },
    closeRemarks() {
      this.$refs["remarks"].hide();
    },
    printGrn() {
      let manuName = "";
      if (this.state.system.printer != "") {
        manuName = this.state.system.printer;
      }
      this.$loading = true;
      let data = {
        // id: this.$route.params.id,
        // api_token: this.state.token,
        // v_id: this.state.user.v_id,
        // store_id: this.state.user.store_id,
        // vu_id: this.state.user.id,
        // grn_no: this.$route.params.grn_no,
        // trans_from: this.state.trans_from,
        // udidtoken: this.state.trans_from
        url: "/vendor/grn-print",
      };

      axios
        .get(data, {
          params: {
            api_token: this.state.sessions.user.api_token,
            v_id: this.state.sessions.user.user.v_id,
            store_id: this.state.sessions.user.store_id,
            vu_id: this.state.sessions.user.user.vu_id,
            grn_no: this.grn.grn_no,
            trans_from: this.state.system.trans_from,
            // udidtoken: this.state.trans_from,
            terminal_id: this.state.system.settings.terminal_id,
            manufacturer_name: manuName,
          },
        })
        .then((response) => {
          if (this.state.system.printer != "" && qz.websocket.isActive()) {
            this.stringHtml = response.data.print_data
              .replace(
                /<size=24>|<bold>|<\/bold>|<\/size>|<normal>|<\/normal>/gi,
                ""
              )
              .replace(/<center>/gi, "<div class='cool-center'>")
              .replace(/<left>/gi, "<div class='cool-left'>")
              .replace(/<right>/gi, "<div class='cool-right'>")
              .replace(/<text>/gi, "<span>")
              .replace(/<\/text>/gi, "</span>")
              .replace(/<\/center>|<\/left>|<\/right>/gi, "</div>");
            this.stringHtml =
              "<div class='webpos-print'>" + this.stringHtml + "</div>";
            setTimeout(() => {
              this.printHtml();
            }, 1000);
            // this.printHtml(response.data.print_data);
          } else {
            this.$refs["print-grn"].show();
            this.html = response.data.print_data;
          }
          this.$loading = false;
        })
        .catch(() => {
          this.$loading = false;
        });
    },
    saveRemarks() {
      this.GRNList.filter((item) => {
        if (item.barcode == this.remarks.barcode) {
          item.remarks = this.remarks.value;
        }
      });
      this.$refs["remark-modal"].hide();
      this.remarks.value = "";
      this.remarks.barcode = "";
    },
    fetchGRNList: function() {
      this.$loading = true;
      let data = {
        c_id: "",
        api_token: this.state.sessions.user.api_token,
        v_id: this.state.sessions.user.v_id,
        store_id: this.state.sessions.user.store_id,
        vu_id: this.state.sessions.user.vu_id,
        advice_id: this.id,
        trans_from: this.state.system.trans_from,
        terminal_id: this.state.system.settings.terminal_id,
        url: "/vendor/advice-details",
      };
      axios
        .post(data.url, data)
        .then((response) => {
          if (response.data.advice_details == "COMPLETE") {
            alert("GRN already created");
          } else {
            this.GRNList = response.data.data;
            this.advice = response.data.advice_details;
          }
          this.$loading = false;
        })
        .catch(() => {
          this.$loading = false;
        });
    },
    openQty(data) {
      let self = this;
      this.$refs["quantity-modal"].show();
      this.modalData = data;
      this.received_qty = data.received;
      this.damage_qty = data.damaged;
      if (data.batch.length > 0) {
        data.batch.map((batch) => {
          self.list.push({
            type: "Batch",
            number: batch.batch_no,
            received: batch.received_qty,
            damaged: batch.damaged_qty,
          });
        });
      }
      if (data.serial.length > 0) {
        data.serial.map((serial) => {
          self.list.push({
            type: "Serial",
            number: serial.serial_no,
            received: serial.received_qty,
            damaged: serial.damaged_qty,
          });
        });
      }
    },
    closeQtyModal() {
      this.$refs["quantity-modal"].hide();
      this.modalData = [];
      this.list = [];
      this.received_qty = 0;
      this.damage_qty = 0;
    },
    getValue(value) {
      this.search = value;
    },
    addRow(type) {
      this.list.push({
        type: type,
        number: "",
        received: "",
        damaged: "",
      });
    },
    removeRow(index) {
      this.list.splice(index, 1);
      this.changeQty();
    },
    changeQty() {
      let received = 0;
      let damaged = 0;
      // let lost_qty = 0;
      this.list.map((item) => {
        if (item.received == "") {
          item.received = 0;
        }
        if (item.damaged == "") {
          item.damaged = 0;
        }
        received += parseInt(item.received);
        damaged += parseInt(item.damaged);
        // item.lost_qty = 0;
        // }
      });
      console.log("Received :- " + received);
      console.log("Damaged :- " + damaged);
      this.received_qty = received;
      this.damage_qty = damaged;
    },
    updateQty(data) {
      this.GRNList.filter((item) => {
        if (item.barcode == data) {
          let totalQty =
            parseInt(this.received_qty) + parseInt(this.damage_qty);

          let totalOrder = item.order_qty;
          if (this.advice.status == "PARTIAL") {
            totalOrder = item.remaining_qty;
          }
          console.log("Total Order: - " + totalOrder);
          console.log("Total Qty: - " + totalQty);
          console.log("Lost: - " + totalQty);
          if (totalQty == totalOrder) {
            item.temp_status = "";
            item.lost_qty = 0;
          } else if (totalQty > totalOrder) {
            item.lost_qty = totalQty - totalOrder;
            item.temp_status = "Surplus";
          } else if (totalQty < totalOrder) {
            item.lost_qty = -Math.abs(totalQty - totalOrder);
            item.temp_status = "Deficit";
          }

          item.received_qty = this.received_qty;
          item.damage_qty = this.damage_qty;

          if (this.list.length > 0) {
            // console.log(item.batch);
            item.batch = [];
            this.list.map((num) => {
              item.batch.push({
                batch_no: num.number,
                exp_date: "",
                mfg_date: "",
                received_qty: num.received,
                damaged_qty: num.damaged,
                valid_months: "",
              });
            });
          }
        }
        return item;
      });
      this.$refs["quantity-modal"].hide();
      this.received_qty = 0;
      this.damage_qty = 0;
      this.list = [];
      this.modalData = [];
    },
    createGrn() {
      this.$loading = true;
      let self = this;
      let data = [];
      let totalRequestQty = 0;
      let totalGetQty = 0;
      this.GRNList.map((item) => {
        if (this.advice.status == "PARTIAL") {
          totalRequestQty += parseInt(item.remaining_qty);
        } else {
          totalRequestQty += parseInt(item.order_qty);
        }
        totalGetQty +=
          parseInt(item.received_qty) +
          parseInt(item.damage_qty) +
          parseInt(item.lost_qty);
        if (item.received_qty > 0 || item.damage_qty > 0 || item.lost_qty) {
          data.push({
            barcode: item.barcode,
            advice_list_id: item.id,
            received_qty: item.received_qty,
            damage_qty: item.damage_qty,
            lost_qty: item.lost_qty,
            remarks: item.remarks,
            batch: item.batch,
            serial: item.serial,
          });
        }
      });
      // console.log(data);

      // if (data.length > 0) {
      //   if (totalGetQty < totalRequestQty) {
      //     this.$bvModal
      //       .msgBoxConfirm(msg.SHORT_EXCESS, {
      //         title: "Please confirm",
      //         size: "sm",
      //         buttonSize: "sm",
      //         okVariant: "danger",
      //         okTitle: "Yes",
      //         cancelTitle: "No",
      //         footerClass: "p-2",
      //         hideHeaderClose: false,
      //         centered: true
      //       })
      //       .then(res => {
      //         if (res) {
      //           self.createFullGrn();
      //         } else {
      //           self.createGrnAPICall(data);
      //         }
      //       })
      //       .catch(err => {});
      //   } else {
      //     // console.log(data);
      //     self.createGrnAPICall(data);
      //   }
      // }

      if (data.length == this.GRNList.length) {
        // console.log("hi");
        self.createFullGrn();
      } else if (data.length > 0 && data.length < this.GRNList.length) {
        // console.log("bye");
        this.$bvModal
          .msgBoxConfirm(msg.SHORT_EXCESS, {
            title: "Please confirm",
            size: "md",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "Create Partial GRN",
            cancelTitle: "Create Full GRN",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          })
          .then((res) => {
            this.$loading = false;
            if (res) {
              self.createGrnAPICall(data);
            } else {
              // self.createGrnAPICall(data);
              let alertData = {
                message: msg.FULL_GRN,
                type: "danger",
              };
              this.$showAlert = true;
              this.$store.commit("notifications/showAlert", alertData);
              // console.log("lol");
            }
          })
          .catch(() => {});
      } else {
        let errorData = {
          msg: msg.CREATE_GRN,
          btntext: "Continue",
          status: "customer_not_tag",
        };
        this.$store.commit("notifications/showMessage", errorData);
      }
    },
    createFullGrn() {
      let self = this;
      let data = [];
      this.GRNList.map((item) => {
        let lost_qty = 0;
        let totalRequestQty = 0;
        let totalGetQty = 0;
        if (this.advice.status == "PARTIAL") {
          totalRequestQty += parseInt(item.remaining_qty);
        } else {
          totalRequestQty += parseInt(item.order_qty);
        }
        totalGetQty = parseInt(item.received_qty) + parseInt(item.damage_qty);
        lost_qty = totalRequestQty - totalGetQty;
        data.push({
          barcode: item.barcode,
          advice_list_id: item.id,
          received_qty: item.received_qty,
          damage_qty: item.damage_qty,
          lost_qty: lost_qty,
          remarks: item.remarks,
          batch: item.batch,
          serial: item.serial,
        });
      });
      // console.log(data);
      self.createGrnAPICall(data);
    },
    printInvoice() {
      let prtContent = document.getElementById("cool");
      let WinPrint = window.open(
        "",
        "",
        "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0"
      );
      WinPrint.document.write("<html><head><title>Print Bill</title>");
      WinPrint.document.write("<style>table{text-align:center}</style>");
      WinPrint.document.write("</head><body>");
      WinPrint.document.write("<div>");
      WinPrint.document.write(prtContent.innerHTML);
      WinPrint.document.write("</div>");
      WinPrint.document.write("</body></html>");
      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
    },
    hidePrintModal() {
      this.$loading = false;
      this.$refs["print-grn"].hide();
      this.$loading = false;
    },
    printHtml() {
      // this.$nextTick(() => {
      let billData = [];
      let data = document.querySelectorAll(".webpos-print");
      // console.log(data);
      for (var i = 0; i < data.length; i++) {
        let tempData = data[i].childNodes;
        for (var j = 0; j < tempData.length; j++) {
          billData.push({
            content: tempData[j].textContent,
            size: tempData[j].textContent.length,
          });
        }
      }
      let htmlData = "";
      htmlData = Object.keys(billData)
        .map(function(k) {
          let convert = "";
          if (billData[k].size == 1) {
            convert = billData[k].content;
            convert = convert.toString();
          } else {
            convert = billData[k].content.substr(
              0,
              billData[k].content.length - 1
            );
            convert = convert + "\x0A";
            convert = convert.toString();
          }
          return convert;
        })
        .join("");
      // console.log(htmlData.toString());

      let config = qz.configs.create(this.state.system.printer, {
        units: "mm",
      });
      let centerAlign = "\x1B" + "\x61" + "\x31";
      let paperCut = "\x1D" + "\x56" + "\x30";
      let lineBreak = "\x0A" + "\x0A" + "\x0A";
      let pdata = [centerAlign + htmlData + lineBreak + paperCut];
      qz.print(config, pdata);
      // console.log(pdata);
      // let self = this;
      // let printerConfig = {
      //   colorType: "blackwhite",
      //   copies: 1,
      //   margins: "0",
      //   rasterize: "false",
      //   rotation: "0",
      //   scaleContent: "false",
      //   units: "mm"
      // };
      // let config = qz.configs.create(this.state.system.printer, printerConfig);
      // let options = {
      //   language: "ESCP"
      // };
      // let size = 11;
      // // Paper width 8 cm
      // let defaultStyle =
      //   "<style>* { font-size: 10px; font-weight: bold; white-space: pre-wrap; margin:0; padding:0; } table {width:280px;  margin-left: -70px; margin-right:0px;  } pre { white-space: pre-wrap; word-wrap: break-word;  } .center { text-align: center; margin-left:-10px } .left { text-align: left; } .right { text-align: right; } .left pre { padding-left:0px !important; } .right pre { padding-left:0px !important; } tbody { display: table !important; }</style>";
      // if (this.printSize == 58) {
      //   // Paper width 5 cm
      //   size = 10;
      //   defaultStyle =
      //     "<style>* { font-size: 8px; font-weight: bold; white-space: pre-wrap; margin:0; padding:0; } table { width:200px;  margin-left:-90px; margin-right:5px } pre { white-space: pre-wrap; word-wrap: break-word;  } .center { text-align: center; } .left { text-align: left; } .right { text-align: right; } .left pre { padding-left:0px !important; } .right pre { padding-left:15px !important; } tbody { display: table !important; width: inherit; word-wrap: break-word; }</style>";
      // }
      // let data = [
      //   {
      //     type: "raw",
      //     format: "html",
      //     flavor: "plain", // or 'plain' if the data is raw HTML
      //     // data: this.state.billing.invoice.data.html_data,
      //     data: "<html><body>" + defaultStyle + html + "</body></html>"
      //     // data:
      //     //   '<html><body><style>* { font-size: 10px; white-space: pre-wrap; }</style><table style="border:1px solid black"><tr><td style="font-size:13px"><b><pre>Pos Store -1\n</pre></b></td></tr><tr><t d style="font-size:12px"><span><pre>D-3 Phase-II Opp Lajpat Nagar Police Station Cool School\n</pre></span></t></tr></table></body></html>'
      //   }
      // ];
      // // console.log(config);
      // qz.print(config, data)
      //   .then(function() {
      //     console.log("Sent data to printer");
      //   })
      //   .catch(function(e) {
      //     console.error(e);
      //   });
    },
    createGrnAPICall(data) {
      this.$loading = true;
      // console.log(data);
      let postData = {
        api_token: this.state.sessions.user.api_token,
        v_id: this.state.sessions.user.v_id,
        store_id: this.state.sessions.user.store_id,
        vu_id: this.state.sessions.user.vu_id,
        advice_id: this.id,
        trans_from: this.state.system.trans_from,
        remarks: this.billRemarks,
        grn_list: JSON.stringify(data),
        terminal_id: this.state.system.settings.terminal_id,
        grnid: "",
        url: "/vendor/create-grn",
      };

      axios
        .post(postData.url, postData)
        .then((res) => {
          this.$loading = false;
          if (res.data.status == "fail") {
            let alertData = {
              message: res.data.message,
              type: "danger",
            };
            this.$showAlert = true;
            this.$store.commit("notifications/showAlert", alertData);
          } else if (res.data.status == "success") {
            this.GRNList = res.data.data.product_list;
            this.grn = res.data.data;
            this.Title = res.data.message;
            let alertData = {
              message: msg.GRN_SUCCESS,
              type: "success",
            };
            this.$showAlert = true;
            this.$store.commit("notifications/showAlert", alertData);
          }
        })
        .catch(() => {
          this.$loading = false;
        });
      this.isApply = true;
    },
    backAdvice() {
      this.$router.push("/advice-list/");
    },
  },
};
</script>
<style lang="scss" scoped>
.custom-select {
  font-size: 13px;
}
.customer-info .vdp-datepicker {
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}
.pill {
  background: $body-color-light;
  border-radius: 5px;
  position: relative;
  &:before {
    width: 7px;
    height: 100%;
    left: 0;
    top: 0;
    content: "";
    position: absolute;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }
}

h4 {
  color: $mid-grey;
}
.pending.pill {
  &:before {
    background: $success-btn;
  }
}
.partial.pill {
  &:before {
    background: $dark-card-text;
  }
}
.complete.pill {
  &:before {
    background: $danger-btn;
  }
}
.customer-info input .form-control,
.b-table .filled {
  background: $body-color-light;
}
.b-table .danger-filled {
  background: $danger-btn;
  color: $white-color;
  &::placeholder {
    color: $white-color;
  }
  &:-ms-input-placeholder {
    color: $white-color;
  }
  &::-ms-input-placeholder {
    color: $white-color;
  }
}
.cart-table {
  .btn {
    padding: 0.375rem 2rem;
  }
  input {
    padding: 1.1rem 0.5rem;
  }
}
.modal-body {
  padding: 10px 0 !important;
  .cart-table input {
    padding: 0.5rem 0.5rem;
    height: auto;
    width: inherit;
  }
  h6 {
    color: $mid-grey;
  }
}
.theme-dark .qty-header {
  h3 {
    font-size: 0.9375rem;
    color: #fff;
  }
}
.padding-less-table {
  border: 0px solid red;
  height: 250px;
  overflow-x: hidden;
  overflow-y: auto;
  @include custom-scrollbar();
  label {
    font-size: 14px;
    margin-top: 8px;
    color: #3f8d8a;
  }
}
.grn th {
  text-align: center;
}
.grn-popup tr:hover {
  background-color: transparent !important;
}
.theme-light .grn-search .form-control:focus {
  background-color: #fff !important;
}
.theme-light textarea.form-control:focus {
  background-color: #fff !important;
  border-color: #ced4da;
}
p {
  color: #c0c0c0;
}
.padding-less-table .table {
  margin: 0px !important;
}
.grn-search .form-control {
  border: none !important ;
}
.update-qty h6 {
  position: absolute;
  left: 0%;
  top: 300px;
}

// .modal-body .form-control:read-only {
//   background-color: transparent !important;
//   border: 1px #c0c0c0 solid !important;
//   color: #808080;
// }

.theme-light .table-dark-bg tbody td label {
  margin-bottom: 0px;
}
.theme-light .table-dark-bg tbody td label .text-danger {
  color: #dc3545 !important;
}
.theme-light .table-dark-bg tbody td label .text-success {
  color: #dc3545 !important;
}

.grn-popup tr td .btn:last-child {
  padding: 0.05rem 0.25rem;
}
.customer-info .form-control {
  background-color: #f0f0f0;
}
// .grn .cart-table p {
//   color: #404040 !important;
// }
.grn .cart-table p span {
  color: #606060 !important;
}
.grn .cart-table .text-muted {
  color: #4fb0ad !important;
}
.grnBox {
  height: calc(100vh - 235px);
}
</style>
